/*
  Copyright (C) SohanIT Inc & JobsHorn. All rights reserved.
  This document contains material and information that is confidential and proprietary to SohanIT Inc & JobsHorn.
  Use and reproduction of this document electronically, copying, regenerating, reengineering, printing, decrypted,
  dissembled, decompiled, reverse-engineered or used to create derivative works or in any form are prohibited and
  governed by U.S. Copyright law. To use, written permission should be obtained from SohanIT Inc & JobsHorn.
*/
import React from 'react';
import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import TextArea from './TextArea';
import { StyledActionButton } from './styles';
import { resumeMatch } from '../../service/resumes';
import { useRouter } from 'next/router';
import CustomBreadcrumbs from '../breadcrumbs/CustomBreadCrumbs';
import { Container, MainContent, SectionHeading, TopSection } from '../common/CommonStyles';

/*
  Business Need: This component provides code to match the resume content

  Program Functionality:
  - compare entered texts and return matched, unmatched words

  Potential Impact if Updated:
  - resume matching under tools will get impacted

  Developer: Madhan
  Date: 27/01/2025
*/

const ResumeMatchingKeywords = () => {
  const navigate = useRouter();
  const [state, setState] = useState({
    resumeText: '',
    jobDescText: '',
  });

  const [matchingData, setMatchingData] = useState(null);
  const [breadcrumbItems, setBreadcrumbsData] = useState([]);

  useEffect(() => {
    const breadcrumbsData = [
      { text: 'Home', link: Cookies.get('token') ? '/prof/myHome' : '/login' },
      { text: 'Resume Word Analyzer' },
    ];
    setBreadcrumbsData(breadcrumbsData);
  }, []);

  const onChange = prop => e => {
    setState({ ...state, [prop]: e.target.value });
  };

  const matchResume = () => {
    const data = {
      resumeText: state?.resumeText,
      jobDescText: state?.jobDescText,
    };
    try {
      const resumeMatchResponse = resumeMatch(data);
      resumeMatchResponse.then(res => {
        if (res?.data && res?.data?.matchKeywords) {
          setMatchingData(res?.data || {});
          navigate.push(
            {
              pathname: '/resume-word-analyzer-results',
              query: { matchingData: JSON.stringify(res?.data || {}) },
            },
            '/resume-word-analyzer-results',
          );
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  const onCancel = prop => () => {
    setState({ ...state, [prop]: '' });
  };

  return (
    <Container sx={{ p: '0px 2.5%' }}>
      <TopSection sx={{ pt: 0 }}>
        <CustomBreadcrumbs bgColor="#fafafa" breadcrumbs={breadcrumbItems} />
        <SectionHeading sx={{ backgroundColor: '#fafafa', mb: 0 }}>Resume Word Analyzer</SectionHeading>
      </TopSection>
      <MainContent sx={{ mt: 0 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} lg={6} md={6}>
            <TextArea
              id="resumeText"
              placeholder="Paste your resume"
              title={'Paste Resume content'}
              clearText={'Clear resume'}
              onChange={onChange('resumeText')}
              value={state.resumeText}
              onCancel={onCancel('resumeText')}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6} md={6}>
            <TextArea
              id="jobDescText"
              placeholder="Paste key words by comma separated or in new lines"
              title={'Paste the words to match'}
              clearText={'Clear the words'}
              onChange={onChange('jobDescText')}
              value={state.jobDescText}
              onCancel={onCancel('jobDescText')}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              margin: '10px 0px',
            }}
          >
            <StyledActionButton
              variant="contained"
              onClick={() => {
                navigate.push(Cookies.get('token') ? '/prof/myHome' : '/login');
              }}
              size="small"
              id="cancel_resume_tool"
            >
              Cancel
            </StyledActionButton>
            <StyledActionButton
              disabled={state?.resumeText === '' || state?.jobDescText === ''}
              variant="contained"
              onClick={matchResume}
              className="primary-dark-color-btn"
              size="small"
              id="match_resume_tool"
            >
              Match Resume
            </StyledActionButton>
          </Grid>
        </Grid>
      </MainContent>
    </Container>
  );
};

export default ResumeMatchingKeywords;
